import { API_ENDPOINTS } from "../ApiEndPoints";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

// Function to fetch category details by ID
export const fetchCategoryDetails = async (categoryId, language) => {
  try {
    const categoryPageUrl = `${BASE_URL}${API_ENDPOINTS.CATEGORIE_PAGE}/${categoryId}`;
    const response = await axios.get(categoryPageUrl, { params: { language } });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error("Failed to fetch category details");
    }
  } catch (error) {
    console.error("Error fetching category details:", error);
    return null;
  }
};
